// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/qywx_jieen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/qywx_jietu.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QYWXSelectModal_custom_modal__G\\+uEf .ant-modal-content {
    width: 100%;
    height: 580px;
    border-radius: 16px;
}

.QYWXSelectModal_main__DyaoA {
    width: 100%;
    height: 500px;
    padding-top: 40px;
}

.QYWXSelectModal_title__22cHj {
    width: 100%;
    height: 46px;
    font-size: 38px;
    font-weight: bold;
    text-align: center;
    color: #262626;
    line-height: 46px;
}

.QYWXSelectModal_butn_container__6\\+a0s {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50%;
    margin-top: 100px;
}

.QYWXSelectModal_butn_box__FXs-1 {
    width: 65%;
    height: 90px;
}

.QYWXSelectModal_butn__UNpnp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 6px;
}

.QYWXSelectModal_butn_en__Kqz\\+7 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
}

.QYWXSelectModal_butn_tu__5WhbY {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/components/QYWXSelectModal/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gFAAkF;AACtF;;AAEA;IACI,gFAAkF;AACtF","sourcesContent":[".custom_modal :global(.ant-modal-content) {\n    width: 100%;\n    height: 580px;\n    border-radius: 16px;\n}\n\n.main {\n    width: 100%;\n    height: 500px;\n    padding-top: 40px;\n}\n\n.title {\n    width: 100%;\n    height: 46px;\n    font-size: 38px;\n    font-weight: bold;\n    text-align: center;\n    color: #262626;\n    line-height: 46px;\n}\n\n.butn_container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 50%;\n    margin-top: 100px;\n}\n\n.butn_box {\n    width: 65%;\n    height: 90px;\n}\n\n.butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.butn_en {\n    background: url('../../../../statics/qywx_jieen.png') no-repeat center / 100% 100%;\n}\n\n.butn_tu {\n    background: url('../../../../statics/qywx_jietu.png') no-repeat center / 100% 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom_modal": `QYWXSelectModal_custom_modal__G+uEf`,
	"main": `QYWXSelectModal_main__DyaoA`,
	"title": `QYWXSelectModal_title__22cHj`,
	"butn_container": `QYWXSelectModal_butn_container__6+a0s`,
	"butn_box": `QYWXSelectModal_butn_box__FXs-1`,
	"butn": `QYWXSelectModal_butn__UNpnp`,
	"butn_en": `QYWXSelectModal_butn_en__Kqz+7`,
	"butn_tu": `QYWXSelectModal_butn_tu__5WhbY`
};
export default ___CSS_LOADER_EXPORT___;
